export default {
  DELETE_FILE_SUCCESS: 'El contenido se ha eliminado correctamente.',
  ADD_CONTENT: 'Añadir contenido para compartir',
  ADD_CONTENT_INFO: 'Cargue aquí sus documentos, enlaces, imágenes u otros materiales para compartir con sus visitantes.',
  NO_CONTENT: 'Aún no ha añadido ningún archivo o enlace.',
  UPLOAD_FILES: 'Subir archivos',
  ADD_URL: 'Añadir URL',
  ADDED_CONTENT: 'Archivos y URL añadidos',
  URL: 'Url',
  ADD_URL_SUCCESS: '¡URL generada y guardada correctamente!',
  DISPLAY_NAME: 'Mostrar nombre',
  BROCHURE: 'Folleto',
  CHOOSE_FILE: 'Elegir archivo',
  DRAG_DROP: 'Arrastrar y soltar',
  TO_UPLOAD: 'Para subir',
  MAX_FILE_SIZE: 'Se permite un tamaño máximo de 3mb',
  MAX_LEN_ERR: 'Nombre de archivo demasiado largo',
  MAX_SIZE_ERR: 'El límite de tamaño de archivo supera',
  FILES_UPLOAD_SUCCESS: 'Archivos subidos correctamente'
}
